<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'home' }">{{
                $t("inicio")
              }}</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'informes' }">{{
                $t("informes")
              }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              {{ $t("gastosDeProveedores") }}
            </li>
          </ol>
        </nav>
      </div>

      <div class="col-md-12">
        <div class="card">
          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label for="listBusiness">{{ $t("negocio") }}</label>

                <el-select
                  class="select-default"
                  size="large"
                  v-model="idBusiness"
                  filterable
                  :placeholder="$t('seleccionaNegocio')"
                  @change="getGastosNegocio(), (procedencia = 2)"
                >
                  <el-option
                    v-for="business in listBusinesses"
                    class="select-primary"
                    :value="business.id"
                    :label="business.establishmentName"
                    :key="business.id"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>

            <div class="col-md-2">
              <div class="form-group">
                <label for="listProcedencia">{{ $t("procedencia") }}</label>

                <el-select
                  class="select-default"
                  size="large"
                  v-model="procedencia"
                  filterable
                  @change="getGastosNegocio()"
                  :placeholder="$t('seleccionaProcedencia')"
                >
                  <el-option
                    class="select-primary"
                    :value="2"
                    :label="$t('todos')"
                    :key="2"
                  >
                  </el-option>
                  <el-option
                    class="select-primary"
                    :value="1"
                    :label="$t('deCaja')"
                    :key="1"
                  >
                  </el-option>
                  <el-option
                    class="select-primary"
                    :value="0"
                    :label="$t('fueraDeCaja')"
                    :key="0"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>

            <div class="col-md-2">
              <div class="form-group">
                <label>{{ $t("fechaInicio") }}</label>
                <datetime
                  value-zone="Europe/Madrid"
                  :auto="true"
                  class="theme-numier"
                  format="dd-MM-yyyy"
                  :title="$t('fechaInicio')"
                  :phrases="{ ok: $t('aceptar'), cancel: $t('salir') }"
                  input-class="form-control"
                  v-model="datefrom"
                ></datetime>
              </div>
            </div>

            <div class="col-md-2">
              <div class="form-group">
                <label>{{ $t("fechaFin") }}</label>
                <datetime
                  value-zone="Europe/Madrid"
                  :auto="true"
                  class="theme-numier"
                  :title="$t('fechaFin')"
                  format="dd-MM-yyyy"
                  :phrases="{ ok: $t('aceptar'), cancel: $t('salir') }"
                  input-class="form-control"
                  v-model="dateto"
                ></datetime>
              </div>
            </div>

            <div class="col-md-2">
              <label>&nbsp;</label>
              <div class="form-group">
                <button class="btn btn-primary" @click="getGastosNegocio()">
                  <img
                    src="static/img/sync.gif"
                    alt=""
                    v-if="loading"
                    width="15"
                  />
                  {{ $t("consultar") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <template v-if="!permiso">
        <div class="alert alert-danger m-3" style="width: 100%" role="alert">
          Lo sentimos. Este negocio no cuenta con este módulo activado.
        </div>
      </template>
      <template v-else-if="respuesta">
        <div class="col-md-8">
          <template v-if="list.length > 0">
            <div class="row justify-content-between div-export">
              <div class="col-md-2 col-xs-12 text-right">
                <el-dropdown>
                  <el-button type="primary" size="small">
                    <i class="fa fa-file"></i>
                    {{ $t("exportarInforme") }}
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <a :href="urlExportPDF">
                      <el-dropdown-item class="text-danger">
                        <strong
                          ><i class="fa fa-file-pdf"></i>
                          {{ $t("exportarPdf") }}</strong
                        >
                      </el-dropdown-item>
                    </a>
                    <a :href="urlExportExcel">
                      <el-dropdown-item class="text-success">
                        <strong
                          ><i class="fa fa-file-excel"></i>
                          {{ $t("exportarExcel") }}</strong
                        >
                      </el-dropdown-item>
                    </a>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>

            <div class="table-responsive">
              <table class="table table-bordered table-striped text-nowrap">
                <thead class="thead-dark">
                  <tr>
                    <th>
                      <span
                        v-if="ordenarConcepto"
                        @click="sortedArrayASC(1), (ordenarConcepto = 0)"
                        ><i style="color: white" class="fa fa-angle-up"></i>
                        {{ $t("concepto") }}
                      </span>
                      <span
                        v-else
                        @click="sortedArrayDESC(1), (ordenarConcepto = 1)"
                        ><i style="color: white" class="fa fa-angle-down"></i>
                        {{ $t("concepto") }}
                      </span>
                    </th>
                    <th>
                      <span
                        v-if="ordenarCategoria"
                        @click="sortedArrayASC(2), (ordenarCategoria = 0)"
                        ><i style="color: white" class="fa fa-angle-up"></i>
                        {{ $t("categoria") }}
                      </span>
                      <span
                        v-else
                        @click="sortedArrayDESC(2), (ordenarCategoria = 1)"
                        ><i style="color: white" class="fa fa-angle-down"></i>
                        {{ $t("categoria") }}
                      </span>
                    </th>
                    <th>
                      <span
                        v-if="ordenarImporte"
                        @click="sortedArrayASC(3), (ordenarImporte = 0)"
                        ><i style="color: white" class="fa fa-angle-up"></i>
                        {{ $t("importe") }}
                      </span>
                      <span
                        v-else
                        @click="sortedArrayDESC(3), (ordenarImporte = 1)"
                        ><i style="color: white" class="fa fa-angle-down"></i>
                        {{ $t("importe") }}
                      </span>
                    </th>
                    <th>{{ $t("acciones") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(obj, index) in list">
                    <td>{{ obj.supplierName }}</td>
                    <td>{{ obj.nameTag }}</td>
                    <td class="text-right">{{ obj.price | currency }}</td>
                    <td align="center">
                      <div
                        v-if="obj.ref.length > 0"
                        @click="openModal(index)"
                        class="btn btn-link"
                      >
                        <i
                          class="fas fa-list-ul text-primary"
                          style="cursor: pointer"
                          v-tooltip.top-center="$t('verDesgloseFacturas')"
                        ></i>
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr class="table-success">
                    <td>
                      <strong>{{ $t("total") }}</strong>
                    </td>
                    <td></td>
                    <td class="text-right">
                      <strong>{{ getTotalPrecio | currency }}</strong>
                    </td>
                    <td></td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </template>
          <template v-else>
            <p>
              <i class="fa fa-info-circle"></i>
              <small>
                {{ $t("infoConsumo") }}
              </small>
            </p>
            <div class="alert alert-danger" role="alert">
              {{ $t("noHay") }} <strong>{{ $t("gastos") }}</strong>
              {{ $t("rangoDeFechas") }}
            </div>
          </template>
        </div>

        <div class="col-md-4 " v-show="this.list.length > 0">
          <div class="card">
            <canvas id="chart"></canvas>
          </div>
        </div>
      </template>
    </div>
    <modal
      name="modal-ver-ref"
      :adaptive="true"
      :scrollable="true"
      height="auto"
      :clickToClose="true"
    >
      <div>
        <div class="modal-header">
          <!--                    <h4 style="margin: 0px">Referencias <span class="text-primary">{{nameMateriaFactura}} </span></h4>-->
        </div>
        <div class="modal-body">
          <div class="table-responsive">
            <table class="table table-bordered table-striped">
              <thead class="thead-dark">
                <tr>
                  <th>
                    <span
                      v-if="ordenarModFecha"
                      @click="sortedArrayASC(4), (ordenarModFecha = 0)"
                      ><i style="color: white" class="fa fa-angle-up"></i>
                      {{ $t("nombre") }}
                    </span>
                    <span
                      v-else
                      @click="sortedArrayDESC(4), (ordenarModFecha = 1)"
                      ><i style="color: white" class="fa fa-angle-down"></i>
                      {{ $t("nombre") }}
                    </span>
                  </th>
                  <th>
                    <span
                      v-if="ordenarModReferencia"
                      @click="sortedArrayASC(5), (ordenarModReferencia = 0)"
                      ><i style="color: white" class="fa fa-angle-up"></i>
                      {{ $t("ud") }}
                    </span>
                    <span
                      v-else
                      @click="sortedArrayDESC(5), (ordenarModReferencia = 1)"
                      ><i style="color: white" class="fa fa-angle-down"></i>
                      {{ $t("ud") }}
                    </span>
                  </th>
                  <th>
                    <span
                      v-if="ordenarModTipo"
                      @click="sortedArrayASC(6), (ordenarModTipo = 0)"
                      ><i style="color: white" class="fa fa-angle-up"></i>
                      {{ $t("partes") }}
                    </span>
                    <span
                      v-else
                      @click="sortedArrayDESC(6), (ordenarModTipo = 1)"
                      ><i style="color: white" class="fa fa-angle-down"></i>
                      {{ $t("partes") }}
                    </span>
                  </th>
                  <th>
                    <span
                      v-if="ordenarModImporte"
                      @click="sortedArrayASC(7), (ordenarModImporte = 0)"
                      ><i style="color: white" class="fa fa-angle-up"></i>
                      {{ $t("total") }}
                    </span>
                    <span
                      v-else
                      @click="sortedArrayDESC(7), (ordenarModImporte = 1)"
                      ><i style="color: white" class="fa fa-angle-down"></i>
                      {{ $t("total") }}
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="fac in listFacturas">
                  <td>{{ fac.name }}</td>
                  <td>{{ fac.ud }}</td>
                  <td>{{ fac.partes }}</td>
                  <td>{{ fac.total | currency }}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr class="table-success">
                  <td>
                    <strong>{{ $t("total") }}</strong>
                  </td>
                  <td></td>
                  <td></td>
                  <td>
                    <strong>{{ getTotalFacturas | currency }}</strong>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
        <div class="modal-footer">
          <div align="right" class="col-12">
            <button
              @click="$modal.hide('modal-ver-ref')"
              class="btn btn-danger"
            >
              <i class="fas fa-arrow-circle-left"></i>
              {{ $t("volver") }}
            </button>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import Chart from "chart.js";
import {
  DatePicker,
  Select,
  Option,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Button,
} from "element-ui";
import swal from "sweetalert2";
import moment from "moment";
import { mapState } from 'vuex';

export default {
  created() {
    this.loading = true;
    this.$store.dispatch("setNameRoute", this.$i18n.t("gastosDeProveedores"));
    this.getBusiness();

    if (this.$store.getters.dateTo && this.$store.getters.dateFrom) {
      this.datefrom = this.$store.getters.dateFrom;
      this.dateto = this.$store.getters.dateTo;
    }
  },
  components: {
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
    [Option.name]: Option,
  },
  data() {
    return {
      loading: false,
      datefrom: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        1
      ).toISOString(),
      dateto: new Date().toISOString(),
      listBusinesses: [],
      idBusiness: 0,
      value4: [
        new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        new Date(),
      ],
      list: [],
      mode: 0,
      procedencia: 2,
      $Chart: null,
      objectChart: null,
      contador: 0,

      listFacturas: [],

      //ORDENAR
      ordenarConcepto: 0,
      ordenarCategoria: 0,
      ordenarImporte: 0,

      //ORDENAR MODAL
      ordenarModFecha: 0,
      ordenarModReferencia: 0,
      ordenarModTipo: 0,
      ordenarModImporte: 0,

      respuesta: true,
    };
  },
  computed: {
    ...mapState(["permiso"]),
    urlExportPDF() {
      return (
        this.$store.getters.apiUrl +
        "/suppliers/exportGastosSupplier/PDF?idBusiness=" +
        this.idBusiness +
        "&procedencia=" +
        this.procedencia +
        "&mode=" +
        this.mode +
        "&idSupplier=" +
        this.idSupplier +
        "&datefrom=" +
        moment(this.datefrom)
          .startOf("day")
          .unix() +
        "&dateto=" +
        moment(this.dateto)
          .endOf("day")
          .unix() +
        "&jwt=" +
        this.$store.getters.jwt
      );
    },
    urlExportExcel() {
      return (
        this.$store.getters.apiUrl +
        "/suppliers/exportGastosSupplier/Excel?idBusiness=" +
        this.idBusiness +
        "&procedencia=" +
        this.procedencia +
        "&mode=" +
        this.mode +
        "&idSupplier=" +
        this.idSupplier +
        "&datefrom=" +
        moment(this.datefrom)
          .startOf("day")
          .unix() +
        "&dateto=" +
        moment(this.dateto)
          .endOf("day")
          .unix() +
        "&jwt=" +
        this.$store.getters.jwt
      );
    },
    getTotalFacturas() {
      let xTotal = 0;

      this.listFacturas.forEach(function(x) {
        xTotal += x.total;
      });

      return xTotal;
    },

    getTotalPrecio() {
      let total = 0;
      this.list.forEach(function(d) {
        total += d.price;
      });
      return total;
    },
  },
  methods: {
    openModal(index) {
      this.$modal.show("modal-ver-ref");
      this.listFacturas = this.list[index]["ref"];
    },

    sortedArrayASC: function(nameAtributo) {
      switch (nameAtributo) {
        case 1:
          this.ordenarConcepto = 1;

          function compareConcepto(a, b) {
            if (a.supplierName.toUpperCase() < b.supplierName.toUpperCase())
              return -1;
            if (a.supplierName.toUpperCase() > b.supplierName.toUpperCase())
              return 1;
            return 0;
          }

          return this.list.sort(compareConcepto);

        case 2:
          this.ordenarCategoria = 1;

          function compareCategoria(a, b) {
            if (a.nameTag < b.nameTag) return -1;
            if (a.nameTag > b.nameTag) return 1;
            return 0;
          }

          return this.list.sort(compareCategoria);

        case 3:
          this.ordenarImporte = 1;

          function compareImporte(a, b) {
            if (a.price < b.price) return -1;
            if (a.price > b.price) return 1;
            return 0;
          }

          return this.list.sort(compareImporte);

        case 4:
          this.ordenarModFecha = 1;

          function compareModFecha(a, b) {
            if (a.name.toUpperCase() < b.name.toUpperCase()) return -1;
            if (a.name.toUpperCase() > b.name.toUpperCase()) return 1;
            return 0;
          }

          return this.listFacturas.sort(compareModFecha);

        case 5:
          this.ordenarModReferencia = 1;

          function compareModReferencia(a, b) {
            if (parseFloat(a.ud) < parseFloat(b.ud)) return -1;
            if (parseFloat(a.ud) > parseFloat(b.ud)) return 1;
            return 0;
          }

          return this.listFacturas.sort(compareModReferencia);

        case 6:
          this.ordenarModTipo = 1;

          function compareModTipo(a, b) {
            if (parseFloat(a.partes) < parseFloat(b.partes)) return -1;
            if (parseFloat(a.partes) > parseFloat(b.partes)) return 1;
            return 0;
          }

          return this.listFacturas.sort(compareModTipo);

        case 7:
          this.ordenarModImporte = 1;

          function compareModImporte(a, b) {
            if (a.total < b.total) return -1;
            if (a.total > b.total) return 1;
            return 0;
          }

          return this.listFacturas.sort(compareModImporte);
      }
    },
    sortedArrayDESC: function(nameAtributo) {
      switch (nameAtributo) {
        case 1:
          this.ordenarConcepto = 0;

          function compareConcepto(a, b) {
            if (a.supplierName.toUpperCase() > b.supplierName.toUpperCase())
              return -1;
            if (a.supplierName.toUpperCase() < b.supplierName.toUpperCase())
              return 1;
            return 0;
          }

          return this.list.sort(compareConcepto);

        case 2:
          this.ordenarCategoria = 0;

          function compareCategoria(a, b) {
            if (a.nameTag > b.nameTag) return -1;
            if (a.nameTag < b.nameTag) return 1;
            return 0;
          }

          return this.list.sort(compareCategoria);

        case 3:
          this.ordenarCategoria = 0;

          function compareImporte(a, b) {
            if (a.price > b.price) return -1;
            if (a.price < b.price) return 1;
            return 0;
          }

          return this.list.sort(compareImporte);

        case 4:
          this.ordenarModFecha = 0;

          function compareModFecha(a, b) {
            if (a.name.toUpperCase() > b.name.toUpperCase()) return -1;
            if (a.name.toUpperCase() < b.name.toUpperCase()) return 1;
            return 0;
          }

          return this.listFacturas.sort(compareModFecha);

        case 5:
          this.ordenarModReferencia = 0;

          function compareModReferencia(a, b) {
            if (a.ud > b.ud) return -1;
            if (a.ud < b.ud) return 1;
            return 0;
          }

          return this.listFacturas.sort(compareModReferencia);

        case 6:
          this.ordenarModTipo = 0;

          function compareModTipo(a, b) {
            if (a.partes > b.partes) return -1;
            if (a.partes < b.partes) return 1;
            return 0;
          }

          return this.listFacturas.sort(compareModTipo);

        case 7:
          this.ordenarModImporte = 0;

          function compareModImporte(a, b) {
            if (a.total > b.total) return -1;
            if (a.total < b.total) return 1;
            return 0;
          }

          return this.listFacturas.sort(compareModImporte);
      }
    },

    getBusiness() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
        .then(function(response) {
          vm.listBusinesses = response.data.result;

          if (vm.$store.getters.idBusiness) {
            vm.idBusiness = vm.$store.getters.idBusiness;
          } else {
            vm.idBusiness = response.data.result[0].id;
          }

          vm.getGastosNegocio();
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getGastosNegocio() {
      if (this.datefrom === null || this.dateto === null) {
        swal({
          title: this.$t("ups"),
          text: this.$t("seleccioneUnaFechaDeInicioYUnaFechaDeFin"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
      } else {
        let secondsDesde = moment(this.datefrom).unix();
        let secondsHasta = moment(this.dateto).unix();

        if (secondsHasta < secondsDesde) {
          swal({
            title: this.$t("ups"),
            text: this.$t("laFechaDeInicioNoPuedeSerPosteriorALaDeFin"),
            confirmButtonClass: "btn btn-info btn-fill",
            type: "error",
          });
        } else {
          this.loading = true;

          this.$store.dispatch("setDateTo", this.dateto);
          this.$store.dispatch("setDateFrom", this.datefrom);

          var config = {
            params: {
              idBusiness: this.idBusiness,
              mode: this.mode,
              jwt: this.$store.getters.jwt,
              datefrom: moment(this.datefrom)
                .startOf("day")
                .unix(),
              dateto: moment(this.dateto)
                .endOf("day")
                .unix(),
              procedencia: this.procedencia,
              idSupplier: 0,
            },
            headers: { Authorization: "Bearer " + this.$store.getters.jwt },
          };

          let vm = this;
          this.$store.dispatch("setIdBusiness", this.idBusiness);
          this.axios
            .get(this.$store.getters.apiUrl + "suppliers/getExpenses", config)
            .then(function(response) {
              if (response.data.response) {
                vm.respuesta = true;

                vm.list = response.data.result;

                vm.initChart();
              }else if (response.data.response == false && response.data.rangoMayor == true) {
                swal({
                title: "Lo sentimos",
                text: response.data.result,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "info",
                });
                vm.respuesta = false;
            } else {
                swal({
                  title: vm.$t("accesoDenegado"),
                  text: response.data.message,
                  confirmButtonClass: "btn btn-info btn-fill",
                  type: "error",
                });
                vm.respuesta = false;
              }
              vm.loading = false;
            })
            .catch(function(error) {
              console.log(error);
            });
        }
      }
    },
    arrayContainsCasa(listCasas, nameCasa) {
      let found = false;
      for (let i = 0; i < listCasas.length; i++) {
        if (listCasas[i]) {
          if (listCasas[i].nameCasa === nameCasa) {
            found = true;
            break;
          }
        }
      }
      return found;
    },

    initChart() {
      let labels = this.list.map(function(x) {
        return x.supplierName;
      });

      let data = this.list.map(function(x) {
        return x.price;
      });

      var randomColor = require("randomcolor");

      var colors = randomColor({
        luminosity: "dark",
        count: labels.length,
        format: "rgb",
      });

      let backgroundColors = colors.map(function(x) {
        let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
        return (
          "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 0.6)"
        );
      });

      let borderColors = colors.map(function(x) {
        let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
        return (
          "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 0.3)"
        );
      });

      let hoverBackgroundColors = colors.map(function(x) {
        let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
        return (
          "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 1)"
        );
      });

      if (this.contador == 0) {
        if (this.list.length > 0) {
          this.objectChart = new Chart("chart", {
            type: "pie",
            data: {
              labels: labels,
              datasets: [
                {
                  data: data,
                  backgroundColor: backgroundColors,
                  borderColor: borderColors,
                  hoverBackgroundColor: hoverBackgroundColors,
                  borderWidth: 1,
                },
              ],
            },
            options: {
              legend: {
                display: true,
                position: "bottom",
              },
            },
          });

          this.contador++;
        }
      } else {
        this.objectChart.destroy();

        this.objectChart = new Chart("chart", {
          type: "pie",
          data: {
            labels: labels,
            datasets: [
              {
                data: data,
                backgroundColor: backgroundColors,
                borderColor: borderColors,
                hoverBackgroundColor: hoverBackgroundColors,
                borderWidth: 1,
              },
            ],
          },
          options: {
            legend: {
              display: true,
              position: "bottom",
            },
          },
        });
      }
    },
  },
};
</script>

<style scoped>
a li {
  color: #111;
}

.card {
  padding: 20px;
}

.div-export {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Informes/Proveedores/GastosProveedor.vue